const CloseSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <rect x="-0.5" y="-0.5" width="31" height="31" rx="5.5" transform="matrix(0 -1 -1 0 31 31)" fill="white" />
      <rect x="-0.5" y="-0.5" width="31" height="31" rx="5.5" transform="matrix(0 -1 -1 0 31 31)" stroke="#D5D5D5" />
      <path
        d="M22 20.666V11.3327M15.3333 11.9993L19.3333 15.9993M19.3333 15.9993L15.3333 19.9993M19.3333 15.9993H10"
        stroke="#333333"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CloseSvg;
